import { useLang } from "../../i18n/LangContext";

export const Field = ({ id, label, error, hint, required, children, className = "" }) => {
  const { t } = useLang();
  return (
    <div className={className}>
      <label htmlFor={id} className="mb-2 block text-sm font-semibold text-gray-200">
        {label} {required && <span className="text-[#DC2626]" aria-hidden="true">*</span>}
      </label>
      {children}
      {hint && !error && <p className="mt-1.5 text-xs text-gray-500">{hint}</p>}
      {error && <p id={`${id}-error`} role="alert" data-testid={`${id}-error`} className="mt-1.5 text-sm font-medium text-red-400">{t(error)}</p>}
    </div>
  );
};

export const inputProps = (id, error) => ({
  id,
  name: id,
  "aria-invalid": error ? "true" : "false",
  "aria-describedby": error ? `${id}-error` : undefined,
  "data-testid": `input-${id}`,
  className: "tow-input",
});

export const ChoiceButton = ({ selected, onClick, children, testId, className = "" }) => (
  <button
    type="button"
    role="radio"
    aria-checked={selected}
    data-testid={testId}
    onClick={onClick}
    className={`rounded-lg border px-4 py-3 text-sm font-semibold transition-colors ${selected ? "border-[#FACC15] bg-[#FACC15]/10 text-[#FACC15]" : "border-[#2E2E3A] bg-[#0E0E12] text-gray-200 hover:border-gray-500"} ${className}`}
  >
    {children}
  </button>
);
